import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'

const HomeContact = () => (
  <div className="section section-contact" id="contact">
    <div className="section-wrapper">
      <div className="img-wrapper">
        <img src="/images/contact.png" />
      </div>
      <div className="text-wrapper">
        <h1 className="section-title centered">Contact</h1>
        <p className="contact-content">
          To work with Carter or inquire about public speaking and educational opportunities with him, please click to access a contact form or get in touch with Carter directly via email or phone.
        </p>
        <p className="icon-in-text">
          <FontAwesomeIcon icon={faPhone} color="#0077c0" size="2x" />
          (678) 972-2255
        </p>
        <p className="icon-in-text">
          <FontAwesomeIcon icon={faEnvelope} color="#0077c0" size="2x" />
          <a href="mailto:carter@onemoregeneration.org" target="blank">carter@onemoregeneration.org</a>
        </p>
      </div>
    </div>
  </div>
);

export default HomeContact;
